import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import PromoteEatingFruitsAndVegetablesForm from './PromoteEatingFruitsAndVegetablesForm'
import PromoteEatingFruitsAndVegetablesView from './PromoteEatingFruitsAndVegetablesView'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../../../utils/loading'
import { getSchemaSidebar } from '../../../../redux/actions/sidebar'
import { updateForm4, saveForm4 } from '../../../../redux/actions/background'
import ButtonPanel from '../../../ButtonPanel'
import WhisperMoreContent from '../../../WhisperMoreContent'
import WarningMessage from '../../../../components/message/WarningMessage/WarningMessage'

export default function PromoteEatingFruitsAndVegetablesWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  // const [formSchema, setFormSchema] = useState(formSchemas)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [moreContent, setMoreContent] = useState(true)
  const [moreContentBottom, setMoreContentBottom] = useState(true)

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateForm4(projectId, request)
      } else {
        console.log('call save.')
        response = await saveForm4(projectId, request)
      }
      // console.log('response', response)
      if (response) {
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
        onChangeIsEdit(false)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      aboutSchool: data.aboutSchool || '',
      promoteNutritionResult: data.promoteNutritionResult || '',
      isActivity: data.isActivity,
      activityList: data.isActivity == 'Y' ? data.activityList : [],
      allStudents: data.allStudents || 0,
      thin: data.thin || 0,
      fat: data.fat,
      short: data.short || 0,
      slim: data.slim || 0,
      eatVegetableEnough: data.eatVegetableEnough || 0,
      eatVegetableNotEnough: data.eatVegetableNotEnough || 0,
      notEatVegetable: data.notEatVegetable || 0,
      physicalActivity: data.physicalActivity || 0,
      sourceInfo: data.sourceInfo || '',
      sourceInfoMonth: data.sourceInfoMonth,
      sourceInfoYear: data.sourceInfoYear,
      impactOfProblem: data.impactOfProblem || '',
      effectOnStudents: data.effectOnStudents || '',
    }

    // console.log('request', request)
    handleCallService(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {moreContent && (
        <>
          <div dangerouslySetInnerHTML={{ __html: formSchema.introduction }} />
        </>
      )}

      {formSchema.introduction && (
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <WhisperMoreContent
            isShow={moreContent}
            onClick={() => {
              setMoreContent(!moreContent)
            }}
          />
        </div>
      )}
      {isEdit && showCommandButton ? (
        <PromoteEatingFruitsAndVegetablesForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          getValues={getValues}
        />
      ) : (
        <PromoteEatingFruitsAndVegetablesView schema={formSchema} />
      )}

      <div style={{ textAlign: 'center' }}>
        <WhisperMoreContent
          isShow={moreContentBottom}
          onClick={() => {
            setMoreContentBottom(!moreContentBottom)
          }}
        />
      </div>

      {moreContentBottom && (
        <div
          dangerouslySetInnerHTML={{
            __html: formSchema.footer.replace('{village}', formSchema.villageInfo?.village),
          }}
        />
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || 'ความเป็นมาหลักการและเหตุผล'}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}

// const formSchemas = {
//   header:
//     'ความเป็นมา / หลักการและเหตุผล / ความสำคัญของปัญหา (04 ส่งเสริมการบริโภคผัก ผลไม้และภาวะโภชนาการของนักเรียนในโรงเรียน)',
//   footer:
//     '<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;ด้วยเหตุนี้โรงเรียน &nbsp;<strong>{village}</strong>&nbsp; ได้เล็งเห็นความสำคัญของปัญหาจากการบริโภคอาหารที่ไม่ถูกหลักโภชนาการ เกิดปัญหาภาวะโภชนาการที่จะมีผลกระทบต่อพัฒนาการทั้งร่างกาย สติปัญญา อารมณ์ และสังคม ซึ่งส่งผลต่อสุขภาพโดยรวมของนักเรียน &nbsp;จึงได้จัดทำโครงการส่งเสริมการบริโภคผัก ผลไม้ และภาวะโภชนาการของนักเรียนในโรงเรียนขึ้น โดยเน้นที่การปรับเมนูอาหารกลางวันของแม่ครัว ลดหวาน มัน เค็ม และเพิ่มสัดส่วนของปริมาณผัก ผลไม้ในกระบวนการผลิตอาหารกลางวันให้ถูกต้องตามหลักโภชนาการ &nbsp;จัดสภาพแวดล้อมให้เอื้อต่อสุขภาพ พร้อมสร้างความรู้/ความตระหนักให้นักเรียนเกิดการปรับเปลี่ยนพฤติกรรมการบริโภคอาหารเพื่อสุขภาพตลอดจนลดการบริโภคน้ำหวาน ขนมกรุบกรอบลง และส่งเสริมให้มีการออกกำลังกายอย่างต่อเนื่อง ซึ่งจะนำไปสู่การเปลี่ยนแปลงพฤติกรรมด้านสุขภาพที่ดีของนักเรียนต่อไป</p>',
//   villageInfo: {
//     village: 'XXXX',
//     subDistrict: '',
//     district: '',
//     province: '',
//   },
//   aboutSchool: {
//     description: [
//       'โปรดระบุสภาพปัญหาในปัจจุบันและแนวโน้มที่จะเกิดขึ้นในอนาคต สาเหตุที่ทำให้เกิดปัญหา และแนวทางป้องกัน/แก้ไขปัญหา',
//     ],
//     name: 'aboutSchool',
//     label:
//       'ข้อมูลทั่วไปของโรงเรียน อาทิ ที่ตั้ง ขนาดสถานศึกษา ข้อมูลนักเรียน ข้อมูลครูและบุคลากร สภาพชุมชนโดยรวม',
//     value: '',
//   },
//   promoteNutritionResult: {
//     description: [
//       'อธิบายรูปแบบการบริหารจัดการด้านโภชนาการและสุขภาพของนักเรียนที่โรงเรียนดำเนินงานผ่านมาในรูปแบบการจัดการอาหารกลางวัน เมนูอาหาร แหล่งผัก ผลไม้ที่ซื้อ นโยบายด้านการจัดการด้านอาหาร โภชนาการ การออกกำลังกายทั้งภายในและรอบรั้วโรงเรียน ทั้งด้านที่ประสบความสำเร็จและไม่สำเร็จ มีลักษณะอย่างไร เกิดผลลัพธ์อะไรบ้าง',
//     ],
//     name: 'promoteNutritionResult',
//     label:
//       'มีการดำเนินงานเพื่อส่งเสริมโภชนาการ และสุขภาพของนักเรียนที่ผ่านมาทั้งด้านที่ประสบความสำเร็จและไม่สำเร็จ มีลักษณะอย่างไร เกิดผลลัพธ์อะไรบ้าง พบว่า',
//     value: '',
//   },
//   isActivity: {
//     name: 'isActivity',
//     label: 'โรงเรียนเคยดำเนินงานเพื่อส่งเสริมโภชนาการ และสุขภาพของนักเรียนที่ผ่านมาอย่างไรบ้าง',
//     description: [
//       'อธิบายกิจกรรมและผลที่เกิดขึ้นของกิจกรรมที่เคยดำเนินงาน เช่น การทำเกษตรเพื่ออาหารกลางวัน กิจกรรมส่งเสริมภาวะโภชนาการของนักเรียนกลุ่มเสี่ยง เป็นต้น',
//     ],
//     value: 'Y',
//     options: [
//       {
//         name: 'sol1',
//         disabled: false,
//         label: 'เคย',
//         value: 'Y',
//       },
//       {
//         name: 'sol2',
//         disabled: false,
//         label: 'ไม่เคย',
//         value: 'N',
//       },
//     ],
//   },
//   activityList: {
//     name: 'activityList',
//     value: [
//       {
//         activityName: 'XXX',
//         activityResult: 'SSSSSSSSSSSSSSSSSSSSS',
//       },
//       {
//         activityName: 'YYY',
//         activityResult: '',
//       },
//     ],
//   },
//   activityForm: {
//     activity: {
//       name: 'activity',
//       label: 'กิจกรรมที่',
//       hint: 'ชื่อกิจกรรม',
//       validators: [],
//     },
//     result: {
//       name: 'result',
//       label: 'ผลที่เกิดขึ้น',
//       hint: 'ผลที่เกิดขึ้นจากการทำกิจกรรม',
//       validators: [],
//     },
//   },
//   studentHealthDetailText:
//     'ระบุสถานการณ์ด้านภาวะโภชนาการและสุขภาพของนักเรียนในโรงเรียน มีรายละเอียด ดังนี้',
//   studentHealthInfoText: 'ข้อมูลภาวะโภชนาการและสุขภาพของนักเรียน',
//   allStudents: {
//     name: 'allStudents',
//     label: 'นักเรียนทั้งหมดในโรงเรียน',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     percentLabel: 'ร้อยละ',
//     value: '100',
//     validators: [],
//   },
//   thin: {
//     name: 'thin',
//     label: 'นักเรียนที่มีน้ำหนัก/ส่วนสุง ต่ำกว่าเกณฑ์ (ผอม)',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     percentLabel: 'ร้อยละ',
//     value: '',
//     validators: [],
//   },
//   fat: {
//     name: 'fat',
//     label: 'นักเรียนที่มีน้ำหนัก/ส่วนสุง เกินเกณฑ์ (อ้วน)',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     percentLabel: 'ร้อยละ',
//     value: '',
//     validators: [],
//   },
//   short: {
//     name: 'short',
//     label: 'ส่วนสุงต่ออายุต่ำกว่าเกณฑ์ (เตี้ย)',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     percentLabel: 'ร้อยละ',
//     value: '',
//     validators: [],
//   },
//   slim: {
//     name: 'slim',
//     label: 'สมส่วน (ไม่มีภาวะทุพโภชนาการ)',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     percentLabel: 'ร้อยละ',
//     value: '',
//     validators: [],
//   },
//   eatVegetableEnough: {
//     name: 'eatVegetableEnough',
//     label: 'นักเรียนที่บริโภคผักผลไม้เพียงพอ (มากกว่าครึ่งหนึ่งของมื้อกลางวัน)',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     percentLabel: 'ร้อยละ',
//     value: '',
//     validators: [],
//   },
//   eatVegetableNotEnough: {
//     name: 'eatVegetableNotEnough',
//     label: 'นักเรียนที่บริโภคผักผลไม้ไม่เพียงพอ (น้อยกว่าครึ่งหนึ่งของมื้อกลางวัน)',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     percentLabel: 'ร้อยละ',
//     value: '',
//     validators: [],
//   },
//   notEatVegetable: {
//     name: 'notEatVegetable',
//     label: 'นักเรียนไม่บริโภคผักผลไม้เลย',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     percentLabel: 'ร้อยละ',
//     value: '',
//     validators: [],
//   },
//   physicalActivity: {
//     name: 'physicalActivity',
//     label: 'นักเรียนที่มีกิจกรรมทางกายระดับปานกลางถึงหนักสะสมอย่างน้อย 60 นาที/วัน',
//     preLabel: 'จำนวน',
//     postLabel: 'คน',
//     percentLabel: 'ร้อยละ',
//     value: '',
//     validators: [],
//   },
//   sourceInfo: {
//     name: 'sourceInfo',
//     label: 'แหล่งที่มาของข้อมูล',
//     value: '',
//     hint: 'แหล่งที่มา',
//   },
//   sourceInfoMonth: {
//     options: [
//       {
//         disabled: false,
//         label: 'มกราคม',
//         value: 1,
//       },
//       {
//         disabled: false,
//         label: 'กุมภาพันธ์',
//         value: 2,
//       },
//       {
//         disabled: false,
//         label: 'มีนาคม',
//         value: 3,
//       },
//       {
//         disabled: false,
//         label: 'เมษายน',
//         value: 4,
//       },
//       {
//         disabled: false,
//         label: 'พฤษภาคม',
//         value: 5,
//       },
//       {
//         disabled: false,
//         label: 'มิถุนายน',
//         value: 6,
//       },
//       {
//         disabled: false,
//         label: 'กรกฎาคม',
//         value: 7,
//       },
//       {
//         disabled: false,
//         label: 'สิงหาคม',
//         value: 8,
//       },
//       {
//         disabled: false,
//         label: 'กันยายน',
//         value: 9,
//       },
//       {
//         disabled: false,
//         label: 'ตุลาคม',
//         value: 10,
//       },
//       {
//         disabled: false,
//         label: 'พฤศจิกายน',
//         value: 11,
//       },
//       {
//         disabled: false,
//         label: 'ธันวาคม',
//         value: 12,
//       },
//     ],
//     name: 'sourceInfoMonth',
//     label: 'ข้อมูล ณ เดือน',
//     value: 1,
//     hint: 'เดือน',
//   },
//   sourceInfoYear: {
//     options: [
//       {
//         disabled: false,
//         label: '2564',
//         value: 2564,
//       },
//       {
//         disabled: false,
//         label: '2563',
//         value: 2563,
//       },
//       {
//         disabled: false,
//         label: '2562',
//         value: 2562,
//       },
//     ],
//     name: 'sourceInfoYear',
//     label: 'พ.ศ.',
//     value: null,
//     hint: 'พ.ศ.',
//   },
//   impactOfProblem: {
//     name: 'impactOfProblem',
//     label:
//       'สาเหตุและผลกระทบของปัญหา การบริโภคผักและผลไม้ของนักเรียนในโรงเรียน และภาวะโภชนาการที่มีปัญหาของนักเรียน',
//     value: '',
//   },
//   id: null,
//   type: null,
//   disabled: false,
//   feedbackBySubject: null,
// }
